import { newAxiosIns } from '@/libs/axios'

/**
 * Validasi kredensial Meta Pixel & Access Token
 * @param {Object} payload { pixel_id, access_token }
 */
export function apiValidateMetaCredentials(payload) {
  return newAxiosIns.post('komchat-api/api/v1/meta-capi/validate', payload)
}

/**
 * Ambil konfigurasi Meta CAPI agent
 * @param {string|number} agentId
 */
export function apiGetMetaCapiConfig(agentId) {
  return newAxiosIns.get(`komchat-api/api/v1/agent/${agentId}/meta-capi`)
}

/**
 * Trigger pengiriman test event CAPI (Swagger: agentRetryFailedRequest)
 * @param {Object} payload
 */
export function apiTriggerMetaTestEvent(payload) {
  return newAxiosIns.post('komchat-api/api/v1/meta/capi/test', payload)
}

/**
 * Ambil list log aktivitas CAPI test (Swagger: metaTestLogs)
 * @param {string|number} csAgentId
 * @param {Object} params { limit, page }
 */
export function apiGetMetaCapiLogs(csAgentId, params) {
  return newAxiosIns.get(`komchat-api/api/v1/meta/capi/test/logs/${csAgentId}`, {
    params: {
      cs_agent_id: csAgentId,
      limit: params?.limit || 25,
      page: params?.page || 1,
    },
  })
}

/**
 * Hapus single log CAPI test (Swagger: metaTestLogsDelete)
 * @param {string|number} logId
 */
export function apiDeleteMetaCapiLog(logId) {
  return newAxiosIns.delete(`komchat-api/api/v1/meta/capi/test/logs/${logId}/delete`)
}

/**
 * Clear all logs CAPI test by cs_agent_id (Swagger: metaTestLogsDeleteAll)
 * @param {string|number} csAgentId
 */
export function apiClearMetaCapiLogs(csAgentId) {
  return newAxiosIns.delete(`komchat-api/api/v1/meta/capi/test/logs/cs-agent/${csAgentId}/delete`)
}
